import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useParams, useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import axios from "axios";
import "./details.css";
import LeaveShowGrid from "../ogComponent/leaveShowGrid";
import { IconCoinRupee } from "@tabler/icons-react";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function DetailsofEmp() {
  const [value, setValue] = useState(0);
  const [employeeData, setEmployeeData] = useState(null);
  const { id: employeeId } = useParams();
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleNavigation = () => {
    navigate(`/user/salaryslip/${employeeId}`);
  };

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/account/users-list/${employeeId}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setEmployeeData(response.data);
        console.log("emp is", response.data);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };

    if (employeeId) {
      fetchEmployeeData();
    }
  }, [employeeId]);

  // Map backend response to personal details
  const personalDetails = [
    { label: "Name", value: employeeData?.name || "N/A" },
    { label: "Gender", value: employeeData?.gender || "N/A" },
    { label: "Nationality", value: employeeData?.nationality || "N/A" },
    { label: "Blood Group", value: employeeData?.blood_group || "N/A" },
    { label: "Marital Status", value: employeeData?.marital_status || "N/A" },
    { label: "Educational Level", value: employeeData?.education_level || "N/A" },
  ];

  // Map backend response to job details
  const jobDetails = [
    { label: "Job Position", value: employeeData?.job_position?.job_title || "N/A" },
    { label: "Job Type", value: employeeData?.job_type?.job_type || "N/A" },
    { label: "Department", value: employeeData?.department?.dep_name || "N/A" },
    { label: "Branch", value: employeeData?.branch?.branch_name || "N/A" },
    { label: "Experience", value: employeeData?.work_experience || "N/A" },
    { label: "Joining Date", value: employeeData?.joined_date || "N/A" },
    { label: "End of Probation", value: employeeData?.end_of_probation || "N/A" },
    { label: "Effective Date", value: employeeData?.effective_date || "N/A" },
    { label: "Basic Salary", value: employeeData?.basic_salary || "N/A" },
    { label: "Salary Type", value: employeeData?.type_of_salary?.type_of_salary || "N/A" },
    { label: "Currency", value: employeeData?.currency || "N/A" },
    { label: "Benefits", value: employeeData?.benifits || "N/A" },
    { label: "Bonus", value: employeeData?.bonus || "N/A" },
    { label: "Deduction", value: employeeData?.deduction || "N/A" },
  ];

  // Map backend response to contact details
  const contactDetails = [
    { label: "Email", value: employeeData?.email || "N/A" },
    { label: "Phone Number", value: employeeData?.phone_number || "N/A" },
    { label: "Office Phone", value: employeeData?.office_phone || "N/A" },
    { label: "Address", value: `${employeeData?.address_1 || ""} ${employeeData?.address_2 || ""}`.trim() || "N/A" },
    { label: "City", value: employeeData?.city || "N/A" },
    { label: "State", value: employeeData?.state || "N/A" },
    { label: "Pincode", value: employeeData?.pincode || "N/A" },
    { label: "Relative Name", value: employeeData?.relative_name || "N/A" },
    { label: "Relation", value: employeeData?.relation || "N/A" },
    { label: "Relative Phone Number", value: employeeData?.rel_phone_number || "N/A" },
  ];

  // Map backend response to bank details
  const bankDetails = employeeData?.bank_details?.length > 0 ? [
    { label: "Account Holder Name", value: employeeData.bank_details[0].account_holder_name || "N/A" },
    { label: "Account Number", value: employeeData.bank_details[0].account_number || "N/A" },
    { label: "IFSC Code", value: employeeData.bank_details[0].ifsc_code || "N/A" },
    { label: "Bank Name", value: employeeData.bank_details[0].bank_name || "N/A" },
    { label: "Branch Name", value: employeeData.bank_details[0].branch_name || "N/A" },
  ] : [{ label: "Bank Details", value: "No bank details available" }];

  // Map backend response to documents with human-readable labels
  const documentLabels = {
    passportPhoto: "Passport Photo",
    sslc: "SSLC Certificate",
    adhar: "Aadhar Card",
    pancard: "PAN Card",
  };

  const documents = employeeData?.documents?.length > 0 ? employeeData.documents.map(doc => ({
    label: documentLabels[doc.document_type] || doc.document_type,
    value: doc.file_url ? (
      <a
        href={doc.file}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#5853b7", textDecoration: "underline" }}
      >
        View Document
      </a>
    ) : "N/A"
  })) : [{ label: "Documents", value: "No documents available" }];

  // const showData = {
  //   firstHeader: "Total Days",
  //   firstCount: "176",
  //   secondHeader: "Attendance",
  //   secondCount: "92%",
  //   thirdHeader: "Leaves",
  //   thirdCount: "13",
  // };

  return (
    <>
      <div className="DetailsContainer w-100 h-100 mx-2 mx-sm-4 pt-2 pt-sm-3 pb-3 d-flex gap-4">
        <div className="profileInfo rounded-3 p-3 position-relative">
          <div className="imgContainer d-flex flex-column justify-content-center align-items-center">
            <img
              className="mb-2 border border-1 border-white shadow-lg"
              style={{ width: "150px", height: "150px", borderRadius: "15px" }}
              src={employeeData?.profile_photo || "/assets/user.png"}
              alt="profilePic"
            />
            <h6>{employeeData?.name || "N/A"}</h6>
            <h6 style={{ fontSize: "10px" }}>
              ID - #{employeeData?.id || "PRO-0002"}
            </h6>
          </div>
          <div className="profileDatas pt-3">
            <p>Job Position</p>
            <h6 style={{ fontSize: "13px" }}>
              {employeeData?.job_position?.job_title || "N/A"}
            </h6>
            <p>Department</p>
            <h6 style={{ fontSize: "13px" }}>
              {employeeData?.department?.dep_name || "N/A"}
            </h6>
            <p>Email</p>
            <h6 style={{ fontSize: "13px" }}>{employeeData?.email || "N/A"}</h6>
            <p>Contact No</p>
            <h6 style={{ fontSize: "13px" }}>
              {employeeData?.phone_number || "N/A"}
            </h6>
            <p>Place</p>
            <h6 style={{ fontSize: "13px" }}>{employeeData?.city || "N/A"}</h6>
            <p>Job Status</p>
            <h6 style={{ fontSize: "13px" }}>
              {employeeData?.status ? "Active" : "Inactive"}
            </h6>
          </div>
        </div>
        <div className="mainDetails d-flex flex-column justify-content-start rounded-3 gap-3">
          {/* Attendance & leave section */}
          {/* <LeaveShowGrid showData={showData} /> */}

          <button
            className="btn btn-warning"
            style={{ width: '200px' }}
            onClick={handleNavigation}
          >
            <IconCoinRupee stroke={1} size={20} className="me-2" />
            Show Salary Slip
          </button>

          {/* Tabs for Employee Details */}
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="employee details tabs"
                sx={{
                  minHeight: "35px",
                  "& .MuiTab-root": {
                    minHeight: "35px",
                    height: "35px",
                    padding: "0 16px",
                    fontSize: 'clamp(12px, 1.2vw, 12px)'
                  },
                }}
              >
                <Tab label="Personal Details" {...a11yProps(0)} />
                <Tab label="Job Details" {...a11yProps(1)} />
                <Tab label="Contact Details" {...a11yProps(2)} />
                <Tab label="Bank Details" {...a11yProps(3)} />
                <Tab label="Documents" {...a11yProps(4)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              {/* Personal Details */}
              <div className="d-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "10px" }}>
                {personalDetails.map((detail, index) => (
                  <div
                    key={index}
                    className="personal-detail px-2 pt-1 rounded-2"
                    style={{ backgroundColor: "#eaedff" }}
                  >
                    <p
                      className="mb-1"
                      style={{
                        fontSize: "clamp(9px, 1vw, 11px)",
                        color: "darkgray",
                        fontWeight: "500",
                      }}
                    >
                      {detail.label}
                    </p>
                    <h6
                      className="mb-2"
                      style={{ fontSize: "clamp(12px, 1.2vw, 14px)" }}
                    >
                      {detail.value}
                    </h6>
                  </div>
                ))}
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              {/* Job Details */}
              <div className="d-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "10px" }}>
                {jobDetails.map((detail, index) => (
                  <div
                    key={index}
                    className="job-detail px-2 pt-1 rounded-2"
                    style={{ backgroundColor: "#eaedff" }}
                  >
                    <p
                      className="mb-1"
                      style={{
                        fontSize: "clamp(9px, 1vw, 11px)",
                        color: "darkgray",
                        fontWeight: "500",
                      }}
                    >
                      {detail.label}
                    </p>
                    <h6
                      className="mb-2"
                      style={{ fontSize: "clamp(12px, 1.2vw, 14px)" }}
                    >
                      {detail.value}
                    </h6>
                  </div>
                ))}
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              {/* Contact Details */}
              <div className="d-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "10px" }}>
                {contactDetails.map((detail, index) => (
                  <div
                    key={index}
                    className="contact-detail px-2 pt-1 rounded-2"
                    style={{ backgroundColor: "#eaedff" }}
                  >
                    <p
                      className="mb-1"
                      style={{
                        fontSize: "clamp(9px, 1vw, 11px)",
                        color: "darkgray",
                        fontWeight: "500",
                      }}
                    >
                      {detail.label}
                    </p>
                    <h6
                      className="mb-2"
                      style={{ fontSize: "clamp(12px, 1.2vw, 14px)" }}
                    >
                      {detail.value}
                    </h6>
                  </div>
                ))}
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              {/* Bank Details */}
              <div className="d-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "10px" }}>
                {bankDetails.map((detail, index) => (
                  <div
                    key={index}
                    className="bank-detail px-2 pt-1 rounded-2"
                    style={{ backgroundColor: "#eaedff" }}
                  >
                    <p
                      className="mb-1"
                      style={{
                        fontSize: "clamp(9px, 1vw, 11px)",
                        color: "darkgray",
                        fontWeight: "500",
                      }}
                    >
                      {detail.label}
                    </p>
                    <h6
                      className="mb-2"
                      style={{ fontSize: "clamp(12px, 1.2vw, 14px)" }}
                    >
                      {detail.value}
                    </h6>
                  </div>
                ))}
              </div>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
              {/* Documents */}
              <div className="d-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "10px" }}>
                {documents.map((doc, index) => (
                  <div
                    key={index}
                    className="document-detail px-2 pt-1 rounded-2"
                    style={{ backgroundColor: "#eaedff" }}
                  >
                    <p
                      className="mb-1"
                      style={{
                        fontSize: "clamp(9px, 1vw, 11px)",
                        color: "darkgray",
                        fontWeight: "500",
                      }}
                    >
                      {doc.label}
                    </p>
                    <h6
                      className="mb-2"
                      style={{ fontSize: "clamp(12px, 1.2vw, 14px)" }}
                    >
                      {doc.value}
                    </h6>
                  </div>
                ))}
              </div>
            </CustomTabPanel>
          </Box>
        </div>
      </div>
    </>
  );
}